import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WebServiceService } from '../../shared/services/web-service.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-po-chart',
  templateUrl: './po-chart.component.html',
  styleUrls: ['./po-chart.component.scss']
})
export class PoChartComponent implements OnInit {


  @Input() labels: string[];
  @Input() data: number[];
  @Input() barChartType?: string = 'polarArea';
  @Input() colors?: any = []
  @Input() barlineChartLegend?:boolean=true;
  @Input() title:any;
  ChartLegend:boolean=true;

  lineChartColors: any;
  barChartPlugins = [];

  public options: any = {
    responsive: true,
    legend: {
      display: false
    },
    plugins: {
       datalabels: {
        formatter: function(value, context) {
          let title=context.chart.data.labels[context.dataIndex]+" : "+context.dataset.data[context.dataIndex]
          // console.log(title)
          // console.log(context)
          // console.log(value)
          return title;
        },
        anchor: 'end',
        align: 'end',
        offset: 0, // Gets updated,
        display: true

       },
       cutoutPercentage: 10,
    legend: {
      display: false
    },
    layout: {
      padding: 5,
    },
    scale: {
      scaleLabel: {
        display: true
      },
      ticks: {
        max: 500,
        maxTicksLimit: 1,
        display: true,
      },
      angleLines: {
        display: true
      },
      pointLabels: {
        display: true
      }
    },
    onResize: function() {
      let width:any = document.getElementById("poPendingChart").style.width;
      let padding = this.options.layout.padding
      this.options.plugins.datalabels.offset = width/2-padding
    }

    }
  }
  constructor(private router: Router,public webService: WebServiceService,) { }

  ngOnInit() {
    this.lineChartColors = [{ backgroundColor: this.colors }];
    if(this.barChartType=='line')
    {
      this.setChart();
    }
  }
  public chartClicked(e: any): void {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        // get value by index
        const value = chart.data.datasets[0].data[clickedElementIndex];
        // this.navigateUrl(label,value);
      }
    }
  }

  chartHovered(e: any): void {
  }


setChart()
{
  this.options={}
  this.options = {
    responsive: true,
    plugins: {
      datalabels: {
        formatter: function(value, context) {
          // let title=context.chart.data.labels[context.dataIndex]+" : "+context.dataset.data[context.dataIndex]
          let title=context.chart.data.labels[context.dataIndex]
          // console.log(title)
          // console.log(context)
          // console.log(value)
          return title;
        },
        anchor: 'end',
        align: 'end',
      }
    },
    scales: {
      xAxes: [{
          gridLines: {
              color: "rgba(0, 0, 0, 0)",
          }
      }],
      yAxes: [{
          gridLines: {
              color: "rgba(0, 0, 0, 0)",
          }
          ,
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5,
            // Create scientific notation labels
            callback: function(value, index, values) {
              // console.log(value)
              // console.log(index)
              // console.log(values)
                return value + ' K';
            }
        }
      }]
  }
  }
}
}




// WEBPACK FOOTER //
// /codebuild/output/src1294910137/src/src/app/common/po-chart/po-chart.component.ts